import { Amplify } from 'aws-amplify';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

import 'normalize.css';
import { makeVmsStore } from './backend/make-vms-store';
import App from './App.jsx';

import appInsights, { reactPlugin } from './utils/appInsights.js';
import { createBrowserHistory } from 'history';

if (import.meta.env.MODE === 'production') {
    const browserHistory = createBrowserHistory({ basename: '' });
    appInsights.config.extensionConfig[reactPlugin.identifier]['history'] = browserHistory;
    appInsights.loadAppInsights();
    appInsights.trackPageView();
    // App insights has no config option to grab console logs, but below
    // adding the trackTrace call to all console methods lets those be reported
    const originalConsole = {};
    for (const method in console) {
        originalConsole[method] = console[method];
    }

    for (const method in console) {
        console[method] = (...args) => {
            let severityLevel = 0;
            switch (method) {
                case 'warn':
                    severityLevel = 2;
                    break;
                case 'error':
                    severityLevel = 3;
                    break;
            }
            appInsights.trackTrace({ message: `${[...args]}`, severityLevel: severityLevel });
            originalConsole[method](...args);
        };
    }
}

const params = new URLSearchParams(window.location.search);
const translatedVenues = params.get('translatedVenues') === 'true';
if (translatedVenues) {
    console.log('Translated Venues enabled. This is an experimental feature.');
}

const domNodeContainer = document.getElementById('root');
const initialState = { featureFlags: { translatedVenues } };
const store = makeVmsStore(initialState);

const appClient = import.meta.env.VITE_APP_CLIENT_ID ? import.meta.env.VITE_APP_CLIENT_ID : 'isinodefh48sb8ddikvsa27mo';

Amplify.configure({
    Auth: {
        Cognito: {
            // REQUIRED for Federated Authentication - Amazon Cognito Identity Pool ID
            identityPoolId: 'us-west-2:51991efb-8aa9-4309-9017-06e6c2e35837',
            // REQUIRED - Amazon Cognito Region
            region: 'us-west-2',
            // OPTIONAL - Amazon Cognito User Pool ID
            userPoolId: 'us-west-2_cN0R00QLk',
            // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
            userPoolClientId: appClient,
            // OPTIONAL - Enforce user authentication prior to accessing AWS resources or not
            mandatorySignIn: false,
            loginWith: {
                oauth: {
                    domain: 'locuslabs.auth.us-west-2.amazoncognito.com',
                    scopes: ['phone', 'email', 'profile', 'aws.cognito.signin.user.admin', 'openid'],
                    redirectSignIn: [
                        'https://www.locusvms.com/venues/',
                        'https://staging.locusvms.com/venues/',
                        'https://develop.locusvms.com/venues/',
                        'https://vms.atrius.com/venues/',
                        import.meta.env.VITE_SIGN_IN_URL,
                    ], // We need to add all of the possible redirects because if not we can get a redirect_mismatch because we have different vms urls aliases
                    redirectSignOut: [
                        'https://www.locusvms.com/',
                        'https://staging.locusvms.com/',
                        'https://develop.locusvms.com/',
                        'https://vms.atrius.com/',
                        import.meta.env.VITE_SIGN_OUT_URL,
                    ],
                    responseType: 'code',
                    providers: ['Acuity-Azure'],
                },
            },
        },
    },
});

createRoot(domNodeContainer).render(
    <Provider store={store}>
        <App />
    </Provider>,
);

// registerServiceWorker()
